import React, { useMemo, useState } from 'react';
import { SetTheme, Theme } from './types';

type Context = {
	theme?: Theme;
	width?: number;
	height?: number;
	setTheme?: SetTheme;
	setWidth?: (width: number) => void;
	setHeight?: (height: number) => void;
};

type Props = {
	children: JSX.Element;
};

export const CanvasContext = React.createContext<Context>({});

export const CanvasContextProvider = ({ children }: Props) => {
	const [theme, setTheme] = useState<Theme>('light');
	const [width, setWidth] = useState<number>(0);
	const [height, setHeight] = useState<number>(0);

	const value = useMemo(
		() => ({ theme, setTheme, width, setWidth, height, setHeight }),
		[theme, width, height]
	);

	return (
		<CanvasContext.Provider value={value}>{children}</CanvasContext.Provider>
	);
};
